import * as React from "react";
import { forwardRef } from "react";
const SvgTelephoneHangup = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M49.351 30.563c11.78-.07 23.575 1.54 35.376 4.832l.595 1.13a14.3 14.3 0 0 1 6.266 4.228 14.28 14.28 0 0 1-.231 18.777c-8.788-2.774-16.957-4.698-24.35-5.589a14.28 14.28 0 0 1 1.248-10.821c-12.16-1.633-23.944-2.17-37.04-.863a14.28 14.28 0 0 1 1.762 11.694c-9.118 1.336-17.299 3.158-24.34 5.58a14.28 14.28 0 0 1-2.456-15.227 14.28 14.28 0 0 1 7.155-7.244l.713-1.228c11.76-3.438 23.524-5.196 35.304-5.269z" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephoneHangup);
export default ForwardRef;
